import actionTypes from '../actionTypes';

export const FETCH_DOCUMENTS = actionTypes('FETCH_DOCUMENTS');
export const FETCH_DOCUMENTS_TYPES = actionTypes('FETCH_DOCUMENTS_TYPES');
export const FETCH_DOCUMENT = actionTypes('FETCH_DOCUMENT');
export const UPDATE_DOCUMENT = actionTypes('UPDATE_DOCUMENT');
export const CLEAR_DOCUMENT = actionTypes('CLEAR_DOCUMENT');
export const FETCH_COUNTRIES = actionTypes('FETCH_COUNTRIES');
